import React, { useContext } from "react";
import { Box, Typography } from "@mui/material";
import { TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineOppositeContent, TimelineSeparator } from "@mui/lab";
import SelfBookTaxi from "./SelfBook";
import FulfilledTaxi from "./FulfilledTaxi";
import { PointContext } from "../../../../../contexts/PointContext";






export const BookMeATaxi = () =>{

    const pointContext = useContext(PointContext);
    const {
        transportTimeLabel:timeLabel,
        transportTitle:title,
        transportBodyText:bodyText,
        point:{
            transportData=null
        },
        transportIcon:icon,
        iconPrepped=false
    } = pointContext;

    let selfBook = '1';
    if(transportData){
        ({selfBook} = transportData);
    }
    
    return (
        <TimelineItem>
            <TimelineOppositeContent
                sx={{m: '10px 0'}}
                align="right"
                variant="body2"
                color="text.secondary"
            >
                {timeLabel}
            </TimelineOppositeContent>
            <TimelineSeparator>
                {iconPrepped ?
                    icon
                    :
                    <TimelineDot className="summaryModeDot">
                        {icon}
                    </TimelineDot>
                }
                <TimelineConnector/>
            </TimelineSeparator>
            <TimelineContent sx={{py: '12px', px:2}}>
                <Box sx={{marginLeft:'-10px', marginRight:'10px'}}>
                    <Typography className="summaryTreeTitle" variant="h6" component="span">
                        {title}
                    </Typography>
                    {transportData &&
                        <>
                        {
                            selfBook === '1'? 
                            <SelfBookTaxi/>
                            :
                            <FulfilledTaxi/>
                        }
                        </>
                    }
                </Box>
            </TimelineContent>
        </TimelineItem>
    );

}